// extracted by mini-css-extract-plugin
module.exports = {"image":"ua-z","loaded":"va-z","placeholder":"wa-z"};